// Fuente unica de los colores de escala. Antes el mapa vivia duplicado en
// AuditoriaListItem.vue y DetalleAuditoria.vue, y ademas divergia: el listado
// caia a gris neutro ante una escala desconocida, pero el detalle caia al rojo
// de "Deficiente", mostrando como reprobada una auditoria que no lo era.
const ESCALA_STYLES = {
  Excelente: { background: '#e6f5ec', color: '#27884d' },
  Satisfactorio: { background: '#e6f0fb', color: '#185fa5' },
  Aceptable: { background: '#fff3d6', color: '#a06800' },
  Deficiente: { background: '#ffeaea', color: '#c0002a' }
}

const NEUTRO = { background: '#f6f9fc', color: '#525f7f' }

// El backend ya normaliza la capitalizacion, pero no cuesta nada tolerar lo
// que venga cacheado de una version anterior.
function normalizar (escala) {
  if (!escala) return ''
  var texto = String(escala).trim()
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase()
}

export function estiloEscala (escala) {
  return ESCALA_STYLES[normalizar(escala)] || NEUTRO
}

export function estiloEscalaCss (escala) {
  var s = estiloEscala(escala)
  return 'background:' + s.background + '; color:' + s.color + ';'
}

export default ESCALA_STYLES
